import React from "react";
import { Flex, LoadingIcon } from "basis";
// import Loading from "./Loading";
import styled from 'styled-components'
import { COLOR } from "./theme";
import { Text } from '../components'

const StyledLoadingWrapper = styled.div`
  svg {
    fill: ${COLOR.LATITUDE_BLUE_INDIGO};
  }
`;

const LoadingMessage = ({ message = "", color }) => (
  <Flex direction="column" height="100vh" placeItems="center">
    <StyledLoadingWrapper>
      <LoadingIcon size="medium" />
    </StyledLoadingWrapper>
    <Text align="center" margin="4 2" textStyle="subtitle2" color={color}>
      {message}
    </Text>
  </Flex>
);

export default LoadingMessage;
